<template>
    <table class="table table-hover table-responsive no-overflow">
        <thead>
            <tr>
                <th @click="$emit('sort', 'referenceNumber')">
                    Folio de Clientes
                    <span v-if="clientStore.sortKey === 'referenceNumber'">
                        <i :class="clientStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'creditFacility.loanApplication.referenceNumber')">
                    Folio de Solicitudes
                    <span v-if="clientStore.sortKey === 'creditFacility.loanApplication.referenceNumber'">
                        <i :class="clientStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'creditFacility.prospectus.branchOffice.name')">
                    Matriz y/o Sucursales
                    <span v-if="clientStore.sortKey === 'creditFacility.prospectus.branchOffice.name'">
                        <i :class="clientStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'creditFacility.creditScore.referenceNumber')">
                    Folio de Calificaciones
                    <span v-if="clientStore.sortKey === 'creditFacility.creditScore.referenceNumber'">
                        <i :class="clientStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'creditFacility.creditScore.score')">
                    Score
                    <span v-if="clientStore.sortKey === 'creditFacility.creditScore.score'">
                        <i :class="clientStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'creditFacility.referenceNumber')">
                    Folio de Disposiciones
                    <span v-if="clientStore.sortKey === 'creditFacility.referenceNumber'">
                        <i :class="clientStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th @click="$emit('sort', 'status.name')">
                    Estado
                    <span v-if="clientStore.sortKey === 'status.name'">
                        <i :class="clientStore.sortOrder === 1 ? 'fa fa-arrow-up' : 'fa fa-arrow-down'"></i>
                    </span>
                    <span v-else>
                        <i class="fas fa-sort"></i>
                    </span>
                </th>
                <th>Acciones</th>
            </tr>
        </thead>
        <tbody>
            <template v-if="list.length > 0">
                <tr v-for="item in list" :key="item.id">
                    <td> {{ item.referenceNumber }}</td>
                    <td>{{ item.creditFacility?.loanApplication?.referenceNumber || '' }}</td>
                    <td>{{ item.creditFacility?.prospectus?.branchOffice?.name || '' }}</td>
                    <td>{{ item.creditFacility?.creditScore?.referenceNumber || '' }}</td>
                    <td>{{ item.creditFacility?.creditScore?.score || '' }}</td>
                    <td>{{ item.creditFacility?.referenceNumber || '' }}</td>
                    <td>{{ item.status?.name || '' }}</td>
                    <td>
                        <PrimaryButton 
                            v-if="item.creditFacility?.creditScore?.referenceNumber != null"
                            class="btn-success" 
                            data-target="#modal-lg"
                            @click="$emit('edit', item)" data-toggle="modal"
                        >
                            <i class="fa fa-edit"></i>
                        </PrimaryButton>
                    </td>
                </tr>
            </template>
            <tr v-else>
                <td colspan="8" style="text-align: center;">{{ $getLocaleMessage('common', 'noDataFound') }}</td>
            </tr>
        </tbody>
    </table>
</template>

<script setup>
import PrimaryButton from '@/Components/PrimaryButton.vue';
import { useClientsStore } from '@/pinia/clients.module';
import { getCurrentInstance } from 'vue';

// Props
const props = defineProps({
    list: {
        type: Array,
        default: () => [],
        required: true
    }
});

// Emits
const emit = defineEmits(['sort', 'edit']);

// Store - nombre consistente
const clientStore = useClientsStore();
</script>